export default {
  companyUrl: 'https://demo-www.lwtears.com',
  pliUrl: 'https://demo-pli.lwtears.com',
  digitalProductSupportUrl: 'https://demo-www.lwtears.com/contact-us/digital-product-support',
  digitalAssetsUrl: 'https://a-z-educator-content-demo.lwtears.com',
};
